import { useQuery } from '@tanstack/react-query';
import { get } from '@truefit/http-utils';

import { isSignedIn, useAuth } from '@/features/scaffolding/components/AuthContext';

export interface McpTool {
  name: string;
  description: string;
}

/** The tools as the MCP server advertises them to an agent. */
export const useMcpToolsQuery = () => {
  const { sessionState } = useAuth();

  return useQuery({
    queryKey: ['McpTools'],
    queryFn: async () => {
      const { data } = await get<{ tools: McpTool[] }>('/v1.0/mcp/tools');
      return data.tools;
    },
    enabled: isSignedIn(sessionState),
  });
};

export default useMcpToolsQuery;
